import { Section } from '../styles/InstitutionalViewStyles';
import {
  ProcessMapImageContainer,
  ProcessMapImage,
  DownloadLink,
} from '../styles/ProcessMapStyles';

const ProcessMap = () => {
  const imageUrl =
    'https://comunidadmde.s3.us-east-1.amazonaws.com/intranet/Mapa+de+Procesos+Comunidad.png';
  const pdfUrl =
    'https://comunidadmde.s3.us-east-1.amazonaws.com/intranet/Mapa+de+Procesos+Comunidad.pdf';

  return (
    <Section>
      <h3>
        <i className="fa-solid fa-diagram-project"></i>
        Mapa de Procesos Comunidad MDE
      </h3>
      <ProcessMapImageContainer>
        <ProcessMapImage src={imageUrl} alt="Mapa de Procesos Comunidad MDE" />
        <DownloadLink href={pdfUrl} download target="_blank" rel="noopener noreferrer">
          <i className="fa-solid fa-download"></i>
          Descargar Mapa de Procesos (PDF)
        </DownloadLink>
      </ProcessMapImageContainer>
    </Section>
  );
};

export default ProcessMap;
